function translationObject() {
  if (window.I18n) {
    return { ...window.I18n.translations }
  }
  return {}
}

export default translationObject()
